<script>
import PromoCard from "./promo/PromoCard.vue";
import {
  getPromoEntry,
  isSnoozed,
  updatePromoEntry,
  claimPromoSlot,
  hasCreatedProofs,
} from "./promo/promoState.js";
import { PLAN_SKU_TYPES } from "../../utils/constants";

const PROMO_ID = "starter-upgrade";
const LEGACY_SNOOZE_KEY = "starter-promo::snoozedUntil"; // pre-server-state dismissals
const ELIGIBLE_KEY = "starter-promo::eligible";
const CHECKED_KEY = "starter-promo::checkedThisSession";
const SNOOZE_DAYS = 14;
const MIN_PROOFS = 5;

export default {
  name: "StarterPromoCard",
  components: { PromoCard },
  data() {
    return {
      show: false,
    };
  },
  async mounted() {
    if (window.location.pathname.includes("/billing")) return;
    const sku = _.get(window, "$A.Auth.account.subscriptionState.sku", "");
    if (sku.split("-")[0] !== PLAN_SKU_TYPES.FREE_PLAN) {
      // Upgraded (or unknown) plan: drop any cached eligibility from their free days
      try {
        window.localStorage.removeItem(ELIGIBLE_KEY);
      } catch (e) {
        // localStorage unavailable
      }
      return;
    }
    if (this.isLegacySnoozed()) return;
    const entry = await getPromoEntry(PROMO_ID);
    if (!entry || entry.dismissed || isSnoozed(entry)) return;
    if (!(await hasCreatedProofs(MIN_PROOFS, ELIGIBLE_KEY, CHECKED_KEY))) return;
    if (!claimPromoSlot()) return;
    this.show = true;
  },
  methods: {
    isLegacySnoozed() {
      try {
        return parseInt(window.localStorage.getItem(LEGACY_SNOOZE_KEY) || "0", 10) > Date.now();
      } catch (e) {
        return false;
      }
    },
    dismiss() {
      this.show = false;
      updatePromoEntry(PROMO_ID, { dismissed: true });
    },
    seePlans() {
      this.show = false;
      updatePromoEntry(PROMO_ID, { snoozeDays: SNOOZE_DAYS });
      this.$router.push("/billing");
    },
  },
};
</script>

<template>
  <PromoCard
    :show="show"
    aria-label="Starter plan promotion"
    eyebrow="You're on a roll"
    title="Do more with Starter"
    cta-text="See plans"
    dismiss-label="Dismiss"
    @dismiss="dismiss"
    @cta="seePlans"
  >
    <template #eyebrow-icon>
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    </template>
    You've created 5+ proofs on the free plan. Starter unlocks 150 files per user
    each month, video and audio proofing, and full automation — from $18/user/month.
  </PromoCard>
</template>
